import { Grid, Typography } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import AppCard from "../../components/cards/AppCard";
import {
  getWithdrawalChartInfo,
  getWithdrawalOverview,
} from "../../api/platform/platform.withdrawal";
import { IWithdrawalOverview } from "../../common/interfaces/club.interface";
import BarChart from "../../components/charts/BarChart";
import SideInfo from "./SideInfo";
import { PeriodFilter } from "../../common/enums/common.enums";
import { useTabContext } from "../../context/tabs/TabContext";
import { IStatistics } from "../../common/interfaces/statistic.interface";
import { IChart } from "../../common/interfaces/chart.interface";
import { convertChartData } from "../../common/helpers/chart.helper";
import { convertStatisticData } from "../../common/helpers/statistics.helper";

const PlatformWithdrawal: FC = () => {
  const [withdrawalOverview, setWithdrawalOverview] =
    useState<IWithdrawalOverview>();
  const [cardLoader, setCardLoader] = useState<boolean>(false);
  const [chartTab, setChartTab] = useState<string>(PeriodFilter.DAILY);
  const [withdrawalStatisticInfo, setWithdrawalStatisticInfo] =
    useState<IStatistics>();
  const [withdrawalChartInfo, setWithdrawalChartInfo] = useState<IChart[]>();

  const changeChartTab = (tab: PeriodFilter): void => {
    setChartTab(tab);
  };

  useEffect(() => {
    void getWithdrawalOverviewFromApi();
    void getWithdrawalChartInfoFromApi();
  }, []);

  const getWithdrawalChartInfoFromApi = async () => {
    try {
      const response = await getWithdrawalChartInfo();
      const convertedChartData: IChart[] | undefined = convertChartData(
        response,
        "Withdrawal"
      );
      setWithdrawalChartInfo(convertedChartData);
      const statisticData = convertStatisticData(response);
      setWithdrawalStatisticInfo(statisticData);
      console.log(statisticData);
    } catch (error) {
      console.log(error);
    }
  };

  const getWithdrawalOverviewFromApi = async () => {
    try {
      setCardLoader(true);
      setWithdrawalOverview(await getWithdrawalOverview());
      setCardLoader(false);
    } catch (error) {
      console.log(error);
    }
  };

  const totalWithdrawalAmount = useMemo(() => {
    return withdrawalOverview && withdrawalOverview.totalWithdrawalAmount;
  }, [withdrawalOverview]);

  const withdrawalCount = useMemo(() => {
    return withdrawalOverview ? withdrawalOverview.withdrawalCount : 0;
  }, [withdrawalOverview]);

  return (
    <div>
      <Grid
        container
        spacing={{ xs: 1, md: 2, sm: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Typography
          variant="h4"
          component="span"
          key={`typography1`}
          sx={{
            display: "flex",
            alignItems: "center",
            padding: 1,
            width: "100%",
          }}
        >
          Withdrawal
        </Typography>
        <Grid item xs={12} sm={12} md={4}>
          <AppCard
            label={"Total number of active withdrawals"}
            value={`${totalWithdrawalAmount}`}
            loader={cardLoader}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <AppCard
            label={"Total number of withdrawals"}
            value={`${withdrawalCount}`}
            loader={cardLoader}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <useTabContext.Provider
            value={{
              tab: chartTab,
              changeTab: changeChartTab,
            }}
          >
            <SideInfo
              type={"withdrawal"}
              statisticsData={withdrawalStatisticInfo}
            />
            <BarChart chartData={withdrawalChartInfo} />
          </useTabContext.Provider>
        </Grid>
      </Grid>
    </div>
  );
};

export default PlatformWithdrawal;
